import type { AxiosPromise, AxiosRequestConfig } from 'axios';
import axiosInstance from '@/libs/axios';
import type { ApiResponse } from '@/types';

export default class HttpService {
  public static delete<T>(
    url: string,
    data: string[],
    config: AxiosRequestConfig | undefined = undefined,
  ): AxiosPromise<ApiResponse<T>> {
    return axiosInstance.delete<ApiResponse<T>>(url, { ...config, data });
  }

  public static get<T>(
    url: string,
    params?: unknown,
    config: AxiosRequestConfig | undefined = undefined,
  ): AxiosPromise<ApiResponse<T>> {
    return axiosInstance.get<ApiResponse<T>>(url, {
      ...config,
      params,
    });
  }

  public static post<T>(
    url: string,
    data?: unknown,
    config: AxiosRequestConfig | undefined = undefined,
  ): AxiosPromise<ApiResponse<T>> {
    return axiosInstance.post<ApiResponse<T>>(url, data, config);
  }

  public static patch<T>(
    url: string,
    data?: unknown,
    config: AxiosRequestConfig | undefined = undefined,
  ): AxiosPromise<ApiResponse<T>> {
    return axiosInstance.patch<ApiResponse<T>>(url, data, config);
  }

  public static put<T>(
    url: string,
    data: unknown,
    config: AxiosRequestConfig | undefined = undefined,
  ): AxiosPromise<ApiResponse<T>> {
    return axiosInstance.put<ApiResponse<T>>(url, data, config);
  }

  public static setAuthorizationHeader(accessToken: string): void {
    axiosInstance.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  }

  public static unsetAuthorizationHeader(): void {
    delete axiosInstance.defaults.headers.common.Authorization;
  }
}
